<template>
	<div class="hidden-md-and-up" style="border-bottom: 1px dashed #ddd;" v-if="landingSettings && (landingSettings.applicationLink || shopLink)">
		<div class="d-flex justify-center py-3">
			<a v-if="landingSettings && landingSettings.applicationLink" :href="landingSettings.applicationLink">
				<v-btn class="mr-2 px-2" small dark>
					<v-img height="30" width="30" class="ml-1" src="/android.webp">
					</v-img>
					دانلود اپلیکیشن
				</v-btn>
			</a>
			<a :href="shopLink" v-if="shopLink" target="_blank">
				<v-btn class="mr-2" small dark>
					<v-icon left color="white">mdi-cart</v-icon>
					{{ shopTitle }}
				</v-btn>
			</a>
		</div>
	</div>
</template>

<script>
	import { get } from 'vuex-pathify'
	import router from '@/router'
	// Utilities

	export default {
		name: 'LandingAppBar',

		components: {

		},
		data() {
			return {

			}
		},
		computed: {
			...get('siteConfig', [
				'longTitle', 'isCloud'
			]),
			...get('appSettings', [
				'landingSettings'
			]),
			...get('auth', [
				'getCurrentUser'
			]),
			showRegisterBtn() {
				return (!this.isCloud || (this.isCloud && this.$route.params.customerCode)) && !this.getCurrentUser
			},
			businessTitle() {
				return this.landingSettings?.businessTitle || this.longTitle
			},
			shopLink() {
				return this.landingSettings?.shopLink
			},
			shopTitle() {
				return this.landingSettings?.shopTitle || 'وب سایت فروشگاه'
			}
		},
		methods: {
			goToLogin() {
				router.push({ name: 'Login' }).catch(() => { })
			},
			routeToPlans() {
				// this.$route.params
				this.$router.replace('/cl/plans/' + (this.$route.params.customerCode ? this.$route.params.customerCode : '')).catch(() => { })
			},
			goToRegister() {
				router.push({ name: 'Register', params: { customerCode: this.$route.params.customerCode || 0 } }).catch(() => { })
			}
		},
	}
</script>

<style lang="sass">
</style>
